export interface OnboardingConnectionRefreshOptions {
  forceRefresh?: boolean;
}

export interface RefreshOnboardingConnectionSnapshotOptions<T> {
  refresh: (
    showLoading?: boolean,
    options?: OnboardingConnectionRefreshOptions,
  ) => Promise<T[]>;
  isSnapshotReady: (integrations: T[]) => boolean;
  maxAttempts?: number;
  retryDelayMs?: number;
}

export const refreshOnboardingConnectionSnapshot = async <T>({
  refresh,
  isSnapshotReady,
  maxAttempts = 6,
  retryDelayMs = 500,
}: RefreshOnboardingConnectionSnapshotOptions<T>): Promise<T[]> => {
  let latestIntegrations: T[] = [];

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    latestIntegrations = await refresh(false, { forceRefresh: true });
    if (isSnapshotReady(latestIntegrations) || attempt === maxAttempts - 1) {
      return latestIntegrations;
    }

    if (retryDelayMs > 0) {
      await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
    }
  }

  return latestIntegrations;
};
